import React from 'react';
import moment from 'moment';
import Modal from 'react-modal';
import ReactGA from 'react-ga';
import classnames from 'classnames';
import helper from '../Conversations/helpers';

import StatusBar from './StatusBar';
import Campaign from './Campaign';
import CreateLeadEngageLayover from './CreateCampaignOverlay';
import CampaignDetails from './CampaignDetails';
import DeleteCampaign from './DeleteCampaign';
import Loading from '../common/Loading';
import Submissions from './Submissions';
import NotificationWebhook from './NotificationWebhook';
import Trends from './Trends';
import utils from '../../lib/utils';
import './index.scss';

const trends_options = [
  {value:'BOOKINGS' ,label:'Bookings'},
  {value:'CONVERSION_RATE' ,label:'Conversion Rate'},
  {value:'ENGAGEMENT_RATE' ,label:'Engagement Rate'},
  {value:'SUBMISSIONS' ,label:'Submissions'},
];


class FormResponse extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      progress: 0,
      modelopen: false,
      editmodel: false,
      detailspane: false,
      list_of_months: this.getMonths(5),
      edit: false,
      copyWebhook: false,
      deletePopup: false,
      deletecampaign: false,
      selectedCampaign: undefined,
      updateCampaign:false,
      month: '',
      campaign: '',
      successModal:false,
      campaign_type: 'SESSION',
      activeTrend: 'BOOKINGS',
      activeTab: 'overview',
      updateWebhook: false,
      deleteWebhook: false,
      updateWebhookSuccess: false,
    };
  }

  componentDidMount = () => {
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Lead Engage Tab',
      label: 'Lead Engage Page'
    });
    if (!utils.getCookie('LETAB')) {
      utils.setCookie('LETAB', 'overview');
    }
    if (this.props.business && this.props.business.id) {
    this.props.getFormResponse(this.props.business.id, this.state.campaign_type, this.state.selectedCampaign, this.state.month || moment().format('YYYY-MM'));
    this.props.getCampaignData();
    this.props.postTrends(this.state.campaign , this.state.month || moment().format('YYYY-MM'));
    }
  }

  onCampaignTypeChange = (item) => {
  console.log("new campaign type");
  console.log(item.value);
      this.setState({
        campaign_type: item.value
      });
      this.props.setCampaignType(item.value);
  };

  componentWillReceiveProps(nextProps) {
    console.log('hadle refresh', nextProps.business);

    if (nextProps.business.isInfoFetched && nextProps.business.isInfoFetched !== this.props.business.isInfoFetched && nextProps.business.id) {
      console.log('hadle refresh 1', nextProps.business);
      this.props.getFormResponse(nextProps.business.id, this.state.campaign_type);
      this.props.getCampaignData();
      this.props.postTrends(this.state.campaign, this.state.month || moment().format('YYYY-MM'));
    } else if (nextProps.business.id && !this.props.business.id && nextProps.business.isInfoFetched) {
      this.props.getFormResponse(nextProps.business.id, this.state.campaign_type);
      this.props.getCampaignData();
      this.props.postTrends(this.state.campaign, this.state.month || moment().format('YYYY-MM'));
    }
    if(nextProps.formresponse && nextProps.formresponse.editSucces !== this.props.formresponse.editSucces){
      this.comapaignUpdated();
    }
    if(nextProps.formresponse && nextProps.formresponse.postForm !== this.props.formresponse.postForm){
      this.showSuccess();
    }
    if (nextProps.formresponse && nextProps.formresponse.updateWebhook !== this.props.formresponse.updateWebhook && nextProps.formresponse.successfulwebhook === false && nextProps.formresponse.updateWebhook === false) {
      this.webhookUpdateFail();
    }
    if (nextProps.formresponse && nextProps.formresponse.deleteWebhook !== this.props.formresponse.deleteWebhook && nextProps.formresponse.deleteWebhook === false) {
      this.webhookDelete();
    }
    if (nextProps.formresponse && nextProps.formresponse.updateWebhook !== this.props.formresponse.updateWebhook && nextProps.formresponse.successfulwebhook === true && nextProps.formresponse.updateWebhook === false) {
      this.webhookUpdateSuccess();
    }
  }
  showSuccess=()=>{
    this.setState({
      successModal:true
    })
  }
  comapaignUpdated =()=>{
    this.setState({
      updateCampaign: true,
    })
    setTimeout(() => {
      this.setState({
        updateCampaign: false
      })
    }, 3000);
  }
  webhookUpdateFail = () => {
    this.setState({
      updateWebhook: true,
    })
    setTimeout(() => {
      this.setState({
        updateWebhook: false
      })
    }, 3000);
  }
  webhookDelete = () => {
    this.setState({
      deleteWebhook: true,
    })
    setTimeout(() => {
      this.setState({
        deleteWebhook: false
      })
    }, 3000);
  }
  webhookUpdateSuccess = () => {
    this.setState({
      updateWebhookSuccess: true,
    })
    setTimeout(() => {
      this.setState({
        updateWebhookSuccess: false
      })
    }, 3000);
  }
  getMonths = (no_of_months) => {
    let monthList = [];
    while (no_of_months > -1) {
      monthList.push({ 'key': moment().subtract(no_of_months, 'months').format('YYYY-MM'), 'value': moment().subtract(no_of_months, 'months').format('MMM YYYY') });
      no_of_months--;
    };
    return monthList.reverse();
  }
  getMonthOfCampaing = (id) => {
    const { formresponse } = this.props;
    let campaign = formresponse.formrlist.filter(item => {
      return id === item.id
    })
    return campaign[0];
  }
  onMonthChange = (event, type) => {
    console.log(event.target.value);
    let campaign = '';
    let month = '';
    if (type === 'campaign') {
      campaign = event.target.value;
      month = this.props.formresponse.formresponse.year_month;
      if (this.props.business && this.props.business.id) {
        console.log(month, campaign);
        this.props.postFormResponse(this.props.business.id, month, campaign)
      }
    } else if (type === 'summary') {
      month = event.target.value;
      if (this.props.business && this.props.business.id) {
        console.log(month, campaign);
        this.props.postCampaignData(this.props.business.id, month, campaign)
      }
    } else if (type === 'trends') {
      campaign = event.target.value;
      if (this.props.business && this.props.business.id) {
        console.log(month, campaign);
        this.props.postTrends(campaign, moment().format('YYYY-MM'));
      }
    } else {
      month = event.target.value;
      if (this.props.business && this.props.business.id) {
        console.log(month, campaign);
        this.props.postFormResponse(this.props.business.id, month, campaign)
      }
    }
    this.setState({
      campaign: campaign,
      month: month
    })

  }
  
  getErrorMessage = () => {
    const { formresponse } = this.props;
    console.log('state', this.state);
    if (this.state.campaign) {
      let campaign = this.getMonthOfCampaing(this.state.campaign);
      // Yo-ga girls was created May 6. No data for Dec 2019 found"
      return <div className="message-bar">{campaign.name} was created on {moment(campaign.year_month.split('-')[1], 'MM').format('MMMM')} {campaign.year_month.split('-')[0]}. No data for {moment(formresponse.formresponse.year_month.split('-')[1], 'MM').format('MMMM')} {formresponse.formresponse.year_month.split('-')[0]} found</div>;
    } else {
      return <div className="message-bar">No campaign located for {moment(formresponse.formresponse.year_month.split('-')[1], 'MM').format('MMMM')} {formresponse.formresponse.year_month.split('-')[0]}, pick a different date</div>;
    }
  }
  getErrorMessageCurrentMonth = () => {
    const { formresponse } = this.props;
    console.log('state', this.state);
    if (this.state.campaign) {
      let campaign = this.getMonthOfCampaing(this.state.campaign);
      // Yo-ga girls was created May 6. No data for Dec 2019 found"
      return <div className="message-bar">{campaign.name} was created on {moment(campaign.year_month.split('-')[1], 'MM').format('MMMM')} {campaign.year_month.split('-')[0]}. No data for {moment(formresponse.formresponse.year_month.split('-')[1], 'MM').format('MMMM')} {formresponse.formresponse.year_month.split('-')[0]} found</div>;
    } else {
      return <div className="message-bar">No campaigns setup yet - use the add campaign to add a new one</div>;
    }
  }
  createCampaign = () => {
    this.setState({
      modelopen: true,
    })
    this.props.setCampaignType(this.state.campaign_type);
  }

  closeCampaignModel = () => {
    this.props.clearFormFlags();
    this.setState({
      modelopen: false
    })
  }
  closeSuccessModal=()=>{
    this.setState({
      successModal: false
    })
  }
  openEditModel = (campaign) => {
    console.log('Open Edit',campaign);
    this.props.history.push('/app/addleadengage/'+campaign.id);
  }


  closeEditModel = () => {
    this.props.clearFormFlags();
    this.setState({
      editmodel: false
    })
  }

  openDetailsPane = (campaign) => {
    this.setState({
      selectedCampaign: campaign,
      detailspane: true
    })
    console.log('edit Modal', this.state);
  }
  closeDetailsPane = () => {
    this.setState({
      detailspane: false
    })
  }

  editFromDetails = (campaign) => {
    this.setState({
      detailspane: false,
      selectedCampaign: campaign,
      editmodel: true
    })
  }

  webhookCopy = (campaign) => {
    const el = document.createElement('textarea');
    el.value = campaign.webhook;
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
    this.setState({
      copyWebhook: true,
      selectedCampaign: campaign
    })
    setTimeout(() => {
      this.setState({
        copyWebhook: false
      })
    }, 3000);
  }

  deletePopoup = (campaign) => {
    this.setState({
      deletePopup: true,
      selectedCampaign: campaign
    })
    setTimeout(() => {
      this.setState({
        deletePopup: false
      })
    }, 3000);
  }

  downloadReport = (id) => {
    // const { formresponse} = this.props;
    // let file = window.Config.API_URL+'/business/lead_engage/campaign/'+id+'/report?year_month='+formresponse.formresponse.year_month;
    // window.open(file);
    this.props.history.push('/app/reports/'+id);

  }

  deleteCampaign = (campaign) => {
    const { formresponse } = this.props;
    //this.props.getCampaign({ id: campaign.id, businessId: this.props.business.id, year_month: formresponse.formresponse.year_month })
    this.setState({
      deletecampaign: true,
      selectedCampaign: campaign
    })
  }

  deleteCampaignClose = (campaign) => {
    this.props.clearFormFlags();
    this.setState({
      deletecampaign: false
    })
    if (campaign) {
      this.deletePopoup(campaign);
    }
  }

  sortCampaign = (campaigns) => {
    if (campaigns.length > 0) {
      campaigns.sort((a, b) => {
        return (new Date(a.created_time) > new Date(b.created_time)) ? -1 : 1;
      });
    }
    return campaigns;
  }
  defaultCampaign = () => {
    const { formresponse } = this.props;
    console.log(formresponse.formresponse.campaigns);
    if (formresponse.formresponse.campaigns.length === 1) {
      return formresponse.formresponse.campaigns[0].id;
    } else {
      return false;
    }
  }
  createDisabled = () => {
    const { formresponse } = this.props;
    console.log('status', formresponse.formresponse.lead_engage);
    if (formresponse.formresponse && formresponse.formresponse.lead_engage !== 'ENABLED') {
      return true;
    } else {
      return false;
    }
  }
  footerPostin = () => {
    const { formresponse } = this.props;
    if (formresponse.formresponse &&
      formresponse.formresponse.campaign &&
      formresponse.formresponse.campaign.length > 2
    ) {
      return false;
    } else {
      return true;
    }
  }

  getCreateSucessMessage = (domain) => {
    if (domain === 'DENTAL') {
      return 'The next step is to configure your marketing lead platform to send data to TrueLark Lead Engage so that TrueLark can receive the necessary prospect contact information and start following up.';
    } else {
      return 'Next, you need to setup TrueLark integration externally on your marketing platform in order for TrueLark to start responding and getting data.';
    }
  };

  getWebhookLabel = (domain) => {
    if (domain === 'DENTAL') {
      return 'Below is the unique webhook URL for this campaign.';
    } else {
      return 'Below is your unique url that you should use as a webhook.';
    }
  };

  downloadFullReport = () => {
    const year_month = this.state.month || moment().format('YYYY-MM');
    let file = window.Config.API_URL + '/business/lead_engage/report?year_month=' + year_month;
    window.open(file);
  }
  setActiveTrend = (trend) => {
    utils.setCookie('LETAB', trend);
    this.setState({
      activeTab: trend,
      campaign:'',
    })
  }
  render() {
    const { updateCampaign, successModal, list_of_months, modelopen, editmodel, selectedCampaign, detailspane, copyWebhook, deletecampaign, deletePopup, updateWebhook, updateWebhookSuccess, deleteWebhook } = this.state;
    const { formresponse, business, auth } = this.props;
    const { role } = auth;
    const activeTab = utils.getCookie('LETAB');
    const features = utils.getCookie('feature')
    console.log('updateWebhookSuccess', updateWebhook, updateWebhookSuccess);
    return (
      <div className="form-response ">
        {(formresponse.getFormSummary || !business.isInfoFetched) &&
          <div className="add-campaign_loader">
            <Loading />
          </div>
        }
        {!formresponse.getFormSummary &&
          <>
            <div className='form-response_title'>
              <div className="form-response_title_content">
                <div className="title">Lead Engage</div>
                <button className="add_campaign" style={{ opacity: (this.createDisabled() ? 0.5 : 1) }} onClick={this.createCampaign} disabled={this.createDisabled()}>+ Add new campaign</button>
              </div>
              <div className="form-response_title_meta">
                <div className="icon"><i className="material-icons">help</i></div>
                <div>Need help? Take a look at our guide on how to connect TrueLark to
                  <a className="link-to-social" href="https://www.notion.so/Instapages-Documents-7d4c8d196a994f3988fd488af00ec1c8" target='_blank'>Instapage</a>and
                  <a className="link-to-social" href="https://www.notion.so/Facebook-Leads-Document-ae0409a0ec12434cbd9fa72117690795" target='_blank'>Instagram / Facebook Lead Ads</a></div>
              </div>
    
            {formresponse.formresponse && formresponse.formresponse.lead_engage === 'ENABLED' &&
              <div className="form-response_campaign">
              <div className="form-response_campaign_content">
                <div className="tab-selector">
                    <div className={classnames({ "active": activeTab === "overview" })} onClick={() => this.setActiveTrend("overview")}><div>Overview</div></div>
                    <div className={classnames({ "active": activeTab === "trends" })} onClick={() => this.setActiveTrend("trends")}><div>Trends</div></div>
                    <div className={classnames({ "active": activeTab === "campaigns" })} onClick={() => this.setActiveTrend("campaigns")}><div>Campaigns</div></div>
                    <div className={classnames({ "active": activeTab === "webhook" })} onClick={() => this.setActiveTrend("webhook")}><div>Notification Webhook</div></div>
                </div>
                {activeTab === "overview" &&
                  <>
                    <div className="select-group">
                      <div className="dropdowns">
                        {formresponse.formresponse &&
                          <div className="select-group_container">
                            <select className="select-box" onChange={e => this.onMonthChange(e, 'month')}>
                              {list_of_months.map(month => {
                                return <option value={month.key} selected={month.key === formresponse.formresponse.year_month}>{month.value}</option>
                              })}
                            </select>
                            <i className="material-icons">arrow_drop_down</i>
                          </div>
                        }
                        {formresponse?.campaignlist?.length > 0 &&
                          <div className="select-group_container">
                            <select className="select-box" onChange={e => this.onMonthChange(e, 'campaign')}>
                              <option value=''>All Campaigns</option>
                              {formresponse.campaignlist
                                .filter(form => {
                                  return moment(this.state.month || moment().format('YYYY-MM'), 'YYYY-MM').isSameOrAfter(moment(form.created_year_month, 'YYYY-MM'))
                                })
                                .sort((a, b) => {
                                  const nameA = a.campaign_name || ""; // Fallback to an empty string if null/undefined
                                  const nameB = b.campaign_name || ""; // Fallback to an empty string if null/undefined
                                  return nameA.localeCompare(nameB);
                                })
                                .map(campaign => {
                                  return <option value={campaign.campaign_id}
                                    selected={this.state.campaign === campaign.campaign_id}
                                  >
                                    {campaign.campaign_name}
                                  </option>
                                })
                              }
                            </select>
                            <i className="material-icons">arrow_drop_down</i>
                          </div>
                        }
                      </div>
                      <div className="download-report-container">
                        <div className="download-report-container_button" onClick={this.downloadFullReport}><i className="material-icons">download</i> <span>Download full report</span></div>
                      </div>
                    </div>
                    {formresponse.formresponse &&
                      formresponse.formresponse.campaigns &&
                      formresponse.formresponse.campaigns.length === 0 &&
                      formresponse.formresponse.lead_engage === 'ENABLED' &&
                      <>
                        {formresponse.formresponse.year_month === moment().format('YYYY-MM') ? (
                          this.getErrorMessageCurrentMonth()
                        ) : (
                          this.getErrorMessage()
                        )}
                      </>
                    }
                    {formresponse?.formresponse &&
                      <>
                        <div className="status-bar">
                          <StatusBar formresponse={formresponse.formresponse} auth={auth} />
                        </div>
                      </>
                  }
                    </>}
                  {activeTab === "campaigns" &&
                    <>
                    <div className="campaigns-header">
                      <div className="campaigns-header_title">Campaigns</div>
                      <div className="dropdowns">
                        {formresponse.formresponse &&
                          <div className="select-group_container">
                            <select className="select-box" onChange={e => this.onMonthChange(e, 'summary')}>
                              {list_of_months.map(month => {
                                return <option value={month.key} selected={month.key === formresponse.campaigns.year_month}>{month.value}</option>
                              })}
                            </select>
                            <i className="material-icons">arrow_drop_down</i>
                          </div>
                        }
                        </div>
                    </div>
                  <div className="form-list">
                    <div className="list-container">
                      {formresponse?.campaigns?.campaigns &&
                        this.sortCampaign(formresponse?.campaigns?.campaigns).map(capmaign => {
                          return <Campaign
                            timezone={formresponse?.campaigns?.zone_id}
                            campaign={capmaign}
                            openEditModel={this.openEditModel}
                            openDetailsPane={this.openDetailsPane}
                            webhookCopy={this.webhookCopy}
                            downloadReport={this.downloadReport}
                            deleteCampaign={this.deleteCampaign}
                            auth={auth}
                          />
                        })}
                    </div>
                      </div>
                    </>}
                  {activeTab === "webhook" &&
                    <div>
                      <NotificationWebhook webhook={formresponse.webhook} updateWebHookFunction={this.props.postupdateWebHook}  {...this.props} />
                      </div>
                  }
                  {activeTab === "trends" &&
                    <div>
                      <div className="campaigns-header">
                        <div className="campaigns-header_title">Performance over time</div>
                        <div className="dropdowns">
                          
                            <div className="select-group_container">
                              <select className="select-box" onChange={(e) => this.setState({activeTrend:e.target.value})}>
                              {trends_options.map(trend => {
                                return <option value={trend.value} selected={trend.value === this.state.activeTrend}>{trend.label}</option>
                                })}
                              </select>
                              <i className="material-icons">arrow_drop_down</i>
                            </div>
                        
                          {formresponse?.campaignlist?.length > 0 &&
                            <div className="select-group_container">
                              <select className="select-box" onChange={e => this.onMonthChange(e, 'trends')}>
                                <option value=''>All Campaigns</option>
                                {formresponse.campaignlist
                                  .filter(form => {
                                    return moment(this.state.month || moment().format('YYYY-MM'), 'YYYY-MM')
                                      .isSameOrAfter(moment(form.created_year_month, 'YYYY-MM'));
                                  })
                                  .sort((a, b) => {
                                    const nameA = a.campaign_name || ""; // Fallback to an empty string if null/undefined
                                    const nameB = b.campaign_name || ""; // Fallback to an empty string if null/undefined
                                    return nameA.localeCompare(nameB);
                                  })
                                  .map(campaign => {
                                    return (
                                      <option
                                        value={campaign.campaign_id}
                                        selected={this.state.campaign === campaign.campaign_id}
                                      >
                                        {campaign.campaign_name}
                                      </option>
                                    );
                                  })
                                }
                              </select>
                              <i className="material-icons">arrow_drop_down</i>
                            </div>
                          }
                        </div>
                      </div>
                      <Trends trends={formresponse.trends} business={this.props.business} activeTrend={this.state.activeTrend} />
                    </div>
                  }
                  <CreateLeadEngageLayover modelopen={modelopen} closeCampaignModel={this.closeCampaignModel} webhookCopy={this.webhookCopy} onCampaignTypeChange={this.onCampaignTypeChange} campaign_type={this.state.campaign_type} isLoading={formresponse?.getServiceList} {...this.props} />
                  <CampaignDetails visibility={detailspane} onClose={this.closeDetailsPane} campaign={selectedCampaign} editFromDetails={this.editFromDetails} {...this.props} />
                  <DeleteCampaign campaign={selectedCampaign} modelopen={deletecampaign} deleteCampaignClose={this.deleteCampaignClose} {...this.props} />
                  {copyWebhook &&
                    <div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      Webhook link for “
                      <span>{selectedCampaign.name}</span>
                      ” was copied to your clipboard.
                    </div>
                  }
                  {deletePopup&&
                    <div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      campaign “
                      <span>{selectedCampaign.name}</span>
                      ” was deleted.
                    </div>
                  }
                  {updateWebhookSuccess &&
                    <div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      Webhook is updated.
                    </div>
                  }
                  {updateWebhook &&
                    <div className="copy-webhook-failure">
                      <span className="tick-mark">
                        <i className="material-icons">close</i>
                      </span>
                      Webhook update failed.
                    </div>
                  }
                  {deleteWebhook &&
                    <div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      Webhook is deleted.
                    </div>
                  }
                  
                  {(updateCampaign && !deletePopup)&&
                    <div className="copy-webhook">
                      <span className="tick-mark"><i className="material-icons">check</i></span>
                      campaign “
                      {formresponse.form && formresponse.form.name && <span>{formresponse.form.name}</span>}
                      ” was Updated.
                    </div>
                  }
                </div>
              {activeTab === "overview" &&
                <div className="submissions-container">
                  <Submissions submissions={formresponse?.formresponse?.submission_reports} />
                </div>}
              </div>
            }
            {features && !features.includes('CONTACT_INFO_HIDDEN') && 
            <div className="help-form">Reach us at support@truelark.com or call +1-408-582-7010</div>
            }
          </div>
          
             {formresponse.postForm!== true && formresponse.postFail=== false && formresponse.editSucces!== true && successModal&&
                    <Modal
                      isOpen={true}
                      onAfterOpen={this.afterOpenModal}
                      onRequestClose={this.closeSuccessModal}
                      className="Create-Modal mobile-only"
                      overlayClassName="Overlay"
                      contentLabel="Example Modal"
                    >
                      <div>
                        <div className="modal-header">
                          <div className="title">Campaign created!</div>
                          <button className="modal-close" onClick={this.closeSuccessModal}>
                            X
                          </button>
                          <div className="description">
                            {this.getCreateSucessMessage(auth.domain)}
                          </div>
                          <div className="input">
                            <label className="label-lower">
                              {this.getWebhookLabel(auth.domain)}
                            </label>
                            <div className="group-box">
                              {formresponse.form &&
                              <input
                                type="text"
                                ref={(textarea) => (this.textArea = textarea)}
                                value={formresponse.form.webhook}
                              />
                              }
                              <button
                                className="btn btn--primary btn--lg"
                                onClick={()=>this.webhookCopy(formresponse.form)}
                              >
                                COPY
                              </button>
                            </div>
                            <div className="disclaimer">
                              *You can always copy this link from campaign menu.
                            </div>
                          </div>
                          <div className="help-link">
                            <span className="help-title">Need help?</span> Take a look at our guide on how to connect TrueLark
                            to
                            <a
                              className="link-to-social"
                              href="https://www.notion.so/Instapages-Documents-7d4c8d196a994f3988fd488af00ec1c8"
                              target="_blank"
                            >
                              Instapage
                            </a>
                            and
                            <a
                              className="link-to-social"
                              href="https://www.notion.so/Facebook-Leads-Document-ae0409a0ec12434cbd9fa72117690795"
                              target="_blank"
                            >
                              Instagram / Facebook Lead Ads
                            </a>
                          </div>
                        </div>
                      </div>
                      {this.props.children}
                    </Modal>
                } 
            {formresponse.formresponse && formresponse.formresponse.lead_engage === 'DISABLED' &&
              <>
                <div className="form-response_campaign">
                  <div className="form-response_campaign_content">
                      <div className="upgrade-bar"> <a href="mailto:support@truelark.com">Upgrade </a>to engage your leads from forms, Instagram and Facebook. Feature details<a class="video-link" href={window.Config.FORM_RESPONSE.SUPPORT_VIDEO} target="_blank">here.</a></div>
                    </div>
                </div>
              </>
            }
          </>
        }
      </div>
    );
  }
}
export default FormResponse;
